import type { ElementType } from 'react';
import { useLayout } from './context/layout/LayoutProvider';
import { UnitClassBuilder } from './builders/UnitClassBuilder';
import type { UnitSettings, As } from './ModularTypes/UnitSettings';
import './Unit.css';

const Unit = <T extends As>(props: UnitSettings<T>) => {
  const { context } = useLayout();
  const { className, elementProps } = UnitClassBuilder.build(
    props,
    context.unit || {},
  );
  const { children, as } = props;

  const Component = (as ?? 'div') as ElementType;

  return (
    <Component {...elementProps} className={className}>
      {children}
    </Component>
  );
};

export default Unit;
